const STORAGE_KEY = 'ms-theme'; // system | light | dark

export function getThemePreference() {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === 'light' || v === 'dark' || v === 'system' ? v : 'light';
}

export function resolveTheme(pref = getThemePreference()) {
  if (pref === 'light' || pref === 'dark') return pref;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(pref = getThemePreference()) {
  const resolved = resolveTheme(pref);
  document.documentElement.setAttribute('data-theme', resolved);
  document.documentElement.style.colorScheme = resolved;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', resolved === 'dark' ? '#0F172A' : '#059669');
  return resolved;
}

export function setThemePreference(pref) {
  const next = pref === 'light' || pref === 'dark' ? pref : 'system';
  localStorage.setItem(STORAGE_KEY, next);
  applyTheme(next);
  return next;
}
